import React from 'react';

import {
    CheckCircleOutlined,
    ClockCircleOutlined,
    CloseCircleOutlined,
    ExclamationCircleOutlined,
    SyncOutlined
} from '@ant-design/icons';
import { Tag } from 'antd';
import type { TagProps } from 'antd/es/tag';

const STATUS_MAP = {
    success: {
        backgroundColor: '#f6ffed',
        borderColor: '#b7eb8f',
        color: '#389e0d',
        icon: <CheckCircleOutlined />,
        label: 'success'
    },
    processing: {
        backgroundColor: '#e6f7ff',
        borderColor: '#91d5ff',
        color: '#096dd9',
        icon: <SyncOutlined spin />,
        label: 'processing'
    },
    warning: {
        backgroundColor: '#fffbe6',
        borderColor: '#ffe58f',
        color: '#d48806',
        icon: <ExclamationCircleOutlined />,
        label: 'warning'
    },
    error: {
        backgroundColor: '#fff2f0',
        borderColor: '#ffa39e',
        color: '#cf1322',
        icon: <CloseCircleOutlined />,
        label: 'error'
    },
    default: {
        backgroundColor: '#fafafa',
        borderColor: '#d9d9d9',
        color: '#595959',
        icon: <ClockCircleOutlined />,
        label: 'default'
    },
} as const;

type StatusType = keyof typeof STATUS_MAP;

type StatusTagProps = Omit<TagProps, 'icon'> & {
    status?: StatusType;
    children?: React.ReactNode;
    style?: React.CSSProperties;
};

const StatusTag: React.FC<StatusTagProps> = ({ status = 'default', children, style, ...rest }) => {
    const config = STATUS_MAP[status] ?? STATUS_MAP.default;
    return (
        <Tag
            icon={config.icon}
            style={{
                backgroundColor: config.backgroundColor,
                border: `1px solid ${config.borderColor}`,
                borderRadius: 4,
                color: config.color,
                ...style,
            }}
            {...rest}
        >
            {children ?? ''}
        </Tag>
    );
};

export default StatusTag;